// extracted by mini-css-extract-plugin
export default {"wrapper":"KanbanTableW_wrapper__ayijt","item__wrapper":"KanbanTableW_item__wrapper__UmTKX"};